import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 3rem 0;
  max-width: 74rem;
  margin: 0 auto;
  cursor: pointer;
  &:first-child {
    border-top: 1px solid rgba(0, 0, 0, 0.15);
  }
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  @media (${({ theme }) => theme.respondTo.tablet}) {
    padding: 3.5rem 4rem;
  }
`;

export const HamburgerBar = styled.span`
  background-color: var(--color-secondary);
  display: block;
  width: 1.12rem;
  height: 1.12px;
  margin: 1.12px auto 0;
  @media (${({ theme }) => theme.respondTo.tablet}) {
    width: 1.4rem;
    height: 1.4px;
    margin: 1.4px auto 0;
  }
`;

export const CircleBtn = styled.button`
  flex: 0 0 3.2rem;
  cursor: pointer;
  width: 3.2rem;
  height: 3.2rem;
  background-color: var(--color-primary);
  border: none;
  border-radius: 50%;
  @media (${({ theme }) => theme.respondTo.tablet}) {
    flex: 0 0 4rem;
    width: 4rem;
    height: 4rem;
  }

  svg {
    transform: rotate(45deg);
    vertical-align: middle;
    color: var(--color-secondary);
    width: 1rem;
    @media (${({ theme }) => theme.respondTo.tablet}) {
      width: 1.2rem;
    }
  }
`;

export const Header = styled.h2`
  font-size: 1.6rem;
  line-height: 1.25;
  display: flex;
  align-items: center;
  @media (${({ theme }) => theme.respondTo.tablet}) {
    font-size: 1.9rem;
    width: 100%;
  }
`;

export const Content = styled.p`
  line-height: 1.5;
  font-size: 1.6rem;
  margin-top: 1rem;
  @media (${({ theme }) => theme.respondTo.tablet}) {
    width: 95%;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
